export const responseRedshiftStorages = {
  data: {
    attributes: {
      path: '/ebs/ftpd/test-1641559713622-000001'
    },
    id: 1016
  }
};